import React from 'react'
import icons from '../assets/icons'
import { unCapitalize } from '../utils/string'

type Props = {
  name: string
}

const ShipName: React.FC<Props> = ({ name }: Props) => {
  return (
    <div className='cruise--shipName'>
      <p className='text text--size20 text--nomargin'>{unCapitalize(name)}</p>
    </div>
  )
}

export default ShipName
